<template>
  <div>
    <ul class="nav nav-tabs" role="tablist">
      <li v-for="(tab, index) in tabs" class="nav-item" :key="index">
        <a
          class="nav-link"
          data-toggle="tab"
          role="tab"
          :class="{ active: isActive(tab.id) }"
          @click="select(tab.id)"
          >{{ tab.name }}</a
        >
      </li>
    </ul>

    <div class="card card-body rounded-top">
      <component-table
        entityType="setting"
        :columns="table.columns"
        :data="list"
        :actions="table.actions"
        :total="count"
        @add="goToAddPage"
        @edit="goToEditPage($event.id)"
        @delete="showDeleteDialog($event.id)"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import ComponentTable from '@/components/table/Table';
import { DEFAULT_TABLE_ACTIONS, DEFAULT_COUNT } from '@/utils/constants';
import { listMixin } from '@/mixins/list';
import { tryParseInt } from '@/utils/number';

const messages = {
  listError: 'messages.setting.listError',
  getError: 'messages.setting.getError',
  added: 'messages.setting.added',
  addError: 'messages.setting.addError',
  updated: 'messages.setting.updated',
  updateError: 'messages.setting.updateError',
  deleted: 'messages.setting.deleted',
  deleteConfirm: 'messages.setting.deleteConfirm',
  deleteError: 'messages.setting.deleteError'
};

// @vuese
// Lista ustawień
// @group Setting
export default {
  mixins: [listMixin('setting', messages)],
  computed: {
    ...mapState({
      tabs: state => {
        const tabs = [...state.setting.group.list];
        tabs.unshift({ name: 'Ogólne', id: undefined });
        return tabs;
      }
    })
  },
  data() {
    return {
      selected: {},
      table: {
        columns: [
          { name: 'code', displayName: 'columns.code', sortable: true },
          { name: 'description', displayName: 'columns.description', sortable: true }
        ],
        actions: DEFAULT_TABLE_ACTIONS
      }
    };
  },
  components: {
    ComponentTable
  },

  methods: {
    // @vuese
    // Wybranie grupy
    select(groupId) {
      this.$store.commit('setting/group/setId', groupId);
      this.$router.push({ name: 'settings', params: { groupId } });
    },
    // @vuese
    // Sprawdza czy tab ma być aktywny
    isActive(groupId) {
      return groupId === tryParseInt(this.$route.params.groupId) || (!groupId && !this.$route.params.groupId);
    }
  }
};
</script>
